import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@pella/cosmos-react';
import { QUERY_KEYS } from '../../utils/enums';

/**
 * Hook to fetch all available inventory management divisions.
 * @returns {object} Divisions query result with data, loading, success, and error states.
 */
export const useDivisions = () => {
  const { api, apiReady } = useAPI();
  const { data, isLoading, isSuccess, isError, error } = useQuery({
    queryKey: [QUERY_KEYS.INV_MGMT_DIVISIONS],
    queryFn: () => api.invMgmt.getDivisions(),
    enabled: apiReady,
    staleTime: Number.POSITIVE_INFINITY,
  });
  return {
    divisions: data,
    divisionsIsLoading: isLoading,
    divisionsIsSuccess: isSuccess,
    divisionsIsError: isError,
    divisionsError: error,
  };
};
